import { render, staticRenderFns } from "./FragmentCookingProcess.vue?vue&type=template&id=903e5eca"
import script from "./FragmentCookingProcess.vue?vue&type=script&lang=ts"
export * from "./FragmentCookingProcess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports